import { Box, Button, Typography } from "@mui/material"
import { useMemo } from "react"
import { ItemSolucaoMobile } from "./itemSolucaoMobile"
import theme from "src/theme/light"
import { ModulosMobile } from "./modulosMobile"
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store"

interface ListagemItensSolucaoMobileProps {
  handleOpenModalEstruturas: () => void
  handleChangeModulo?: (moduloId: number) => void
}

export const ListagemItensSolucaoMobile = ({handleOpenModalEstruturas, handleChangeModulo}: ListagemItensSolucaoMobileProps) => {
  const { solucao_calculada, acessorios, estruturas_calculadas } = useProjetosHibridoStore(store => store.state.data)
  const itensSolucao = useMemo(() => {
    return [...solucao_calculada.baterias, ...solucao_calculada.inversores]
  }, [solucao_calculada.baterias, solucao_calculada.inversores])
  
  return (<>
    <ModulosMobile 
      handleChangeModulo={(moduloId: number)=>{
        if(handleChangeModulo){
          handleChangeModulo(moduloId)
        }
      }}
      />
    {itensSolucao.length > 0 && (
      <>
        {itensSolucao.map(item => (
          <ItemSolucaoMobile item={item} tipo_componente={"itens_solucao"} disabledQuantidade={true}/>
        ))}
      </>
    )}
    {acessorios.length > 0 && (
      <>
        {acessorios.map(item => (
          <ItemSolucaoMobile item={item} tipo_componente={"acessorios"}/>
        ))}
      </>
    )}
    {estruturas_calculadas.length > 0 && (
      <>
        {estruturas_calculadas.map(item => (
          <ItemSolucaoMobile item={item} tipo_componente={"estruturas"}/>
        ))}
      </>
    )}
      <Box style={{width: "100%", display: "flex", flexDirection: "row", paddingRight: "10px", paddingBottom: "10px", justifyContent: "space-between"}}>
        <Box style={{width: "50%"}}></Box>
        <Button style={{width: "50%", backgroundColor: theme.palette.warning.dark, color: theme.palette.getContrastText(theme.palette.warning.dark)}} variant="contained" onClick={handleOpenModalEstruturas}><Typography style={{fontSize: "12px"}}>Editar Estruturas</Typography></Button>
      </Box>
  </>)
}